
import { resolveActivities, resolveActivity } from './resolvers/activities.resolver';
import { resolveNestedCategories } from '../event/resolvers/categories.resolver';

export default ['$stateProvider', $stateProvider => {
    $stateProvider
        .state('app.admin.classes', {
            url: '/events/classes?:filtertext',
            component: 'activityList',
            resolve: {
                activities: resolveActivities(),
                categories: resolveNestedCategories('flatten')
            },
            roles: ['manager']
        })
        .state('app.admin.deletedclasses', {
            url: '/events/classes/deleted',
            component: 'activityList',
            resolve: {
                activities: resolveActivities(1, 20, 'deleted')
            },
            roles: ['admin']
        })
        .state('app.admin.class-edit', {
            url: '/events/classes/:activity/update?tab',
            component: 'activitySave',
            resolve: {
                title: () => 'Update a Class',
                activity: resolveActivity()
            },
            roles: ['manager']
        });
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/activity.routes.js